import axios from "axios";
import { cookies, COOKIE_OPTS } from "./cookie";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL ?? "http://localhost:4000",
  withCredentials: true,
});

//  Request interceptor
api.interceptors.request.use(
  function (config) {
    const token = cookies.get("access_token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    // ✅ Cookie-г илгээхийн тулд withCredentials тохируулна
    config.withCredentials = true;

    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

// ✅ Response interceptor (refresh logic)
let refreshPromise = null;

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (!originalRequest) return Promise.reject(error);

    const url = originalRequest.url || "";
    const is401 = error.response?.status === 401;
    const isAuthUrl =
      url.includes("/api/auth/login") || url.includes("/api/auth/refresh");

    if (is401 && !originalRequest._retry && !isAuthUrl) {
      originalRequest._retry = true;

      try {
        if (!refreshPromise) {
          refreshPromise = axios
            .post(
              `${process.env.REACT_APP_API_URL}/api/auth/refresh`,
              {},
              { withCredentials: true },
            )
            .then((res) => {
              const token = res.data.accessToken;
              cookies.set("access_token", token, COOKIE_OPTS);
              return token;
            })
            .finally(() => {
              refreshPromise = null;
            });
        }

        const accessToken = await refreshPromise;
        originalRequest.headers["Authorization"] = `Bearer ${accessToken}`;
        return api(originalRequest);
      } catch (err) {
        cookies.remove("access_token", { path: "/" });
        window.location.href = "/login";
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  },
);

const POST = "POST",
  GET = "GET",
  PUT = "PUT",
  DELETE = "DELETE",
  PATCH = "PATCH",
  URLENCODED = "urlencoded",
  FORMDATA = "formdata",
  JSONDATA = "json";

export default function apiRequest(
  method,
  url,
  data,
  contenttype,
  onUploadProgress,
) {
  let ct;
  if (contenttype === URLENCODED) ct = "application/x-www-form-urlencoded";
  if (contenttype === FORMDATA) ct = "multipart/form-data";
  if (contenttype === JSONDATA) ct = "application/json";

  const config = {
    headers: { ...(ct && { "content-type": ct }) },
    withCredentials: true,
    ...(onUploadProgress && { onUploadProgress }),
  };

  if (method === GET) {
    return api
      .get(url, {
        ...config,
        ...(data && { params: data }),
      })
      .then((res) => res)
      .catch((err) => err.response);
  }

  if (method === POST) {
    return api
      .post(url, data, config)
      .then((res) => res)
      .catch((err) => err.response);
  }

  if (method === PUT) {
    return api
      .put(url, data, config)
      .then((res) => res)
      .catch((err) => err.response);
  }

  if (method === PATCH) {
    return api
      .patch(url, data, config)
      .then((res) => res)
      .catch((err) => err.response);
  }

  if (method === DELETE) {
    return api
      .delete(url, {
        ...config,
        data,
      })
      .then((res) => res)
      .catch((err) => err.response);
  }
}
